import { component } from 'common/util/ComponentDecorator';

@component
export default class formReg {
	static classname = 'form-reg';

	constructor($form) {
		this.$form = $form;

		this.init();
	}

	get $required_inputs() {
		return this.$form.find('.wa-field--required:not(.wa-field-onetime-password) input[type=text]:not(:disabled), .wa-field[data-is-required=1]:not(.wa-field-onetime-password) input[type=text]:not(:disabled)');
	}

	init() {
		if (this.$required_inputs.length) {
			this.$required_inputs.on('input', this.handleInput);
		}

		this.$form.find('.wa-name').each(function () {
			const html = $(this).html();
			$(this).html(html.replace(/\*[\n\s\r]*$/, ''));
		});

		const $phone_input = this.$form.find('.wa-field-phone input');

		if ($phone_input.length) {
			window.PhoneInputMask.mask($phone_input[0]);
			$phone_input.closest('.wa-field').addClass('wa-field--mask');
		}

		const $checkbox = this.$form.find('input[type="checkbox"]');

		if (!$checkbox.length) {
			return;
		}

		const $label = $checkbox.parent('label')

		if ($label.length) {
			$label.addClass('checkbox');
			$('<span class="checkbox__mark"></span>').insertAfter($checkbox);
			$checkbox.addClass('checkbox__input')
		}
	}

	handleInput = () => {
		let count_required_filled = 0;
		this.$required_inputs.each(function () {
			if ($(this).val() !== '') {
				count_required_filled++;
			}
		});
	};
}
